module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/pdp_paperEggshell-78c92fa99bc36bd52a09bfc76e7c3f3b.jpg";